import React, { useEffect, useState } from "react";
import stylesheet from "./faq.module.css";
import Footer from "../../webincludes/footer/index";
import Header from "../../webincludes/header/index";
import { Link } from "react-router-dom";
import Wiggle from "../../component/Wiggle/Wiggle";

const Faqs = () => {
  return (
    <>
      <Wiggle />
      <div className={stylesheet.main_shop}>
        <div>
          <Header />
        </div>
        <div className={`container-fluid ${stylesheet.product_side}`}>
          <div className="row">
            <div className={stylesheet.ShopCard_header}>
              <div className="d-flex pl-5 pr-4 py-4">
                <img src="https://img.icons8.com/material-outlined/20/f0cc00/left.png" />
              </div>
              <div className="d-flex align-items-center">
                <h6>home</h6>
                <h6 className={stylesheet.navigation_breaker}>.</h6>
                <h6 className={stylesheet.header_current_page}>Faqs</h6>
              </div>
            </div>
          </div>
          <div className="row">
            <div className={`col-lg-12 p-5 ${stylesheet.about_sheet}`}>
              <div className="row">
                <div className="col-lg-12">
                  <h5>Who we are and why we're here</h5>
                  <h1>Our Purpose</h1>
                </div>
                <div className="col-lg-6"></div>
                <div
                  className={`col-lg-6 ${stylesheet.rightsidecontet_about} py-5`}
                >
                  <div className="py-5">
                    <p className={stylesheet.question}>
                      At MA True Cannabis, we have optimized the concept of
                      indoor cannabis production: eco-friendly, pesticide free,
                      meticulous care for our plants and a passion for
                      technology, research and development. These are the
                      elements with which we have contributed towards defining a
                      new international standard of True Cannabis production.
                    </p>
                  </div>
                  <p className={stylesheet.answer}>
                    We have created a perfect, protected environment for our CBD
                    Cannabis plants to grow and flourish.
                    <br></br>
                    <br></br>
                    Our CBD Cannabis indoor cultivation features revolutionary
                    low energy consumption LED lighting systems, a unique air
                    conditioning system, the use of entirely organic components
                    throughout all stages of the growing process and development
                    of our plants.
                    <br></br>
                    <br></br>
                    Nature meets science, all supported by the ambition and
                    talent from our team of agricultural engineers, and our
                    passion for the Cannabis plant
                  </p>
                </div>

                <div className={`col-lg-6 ${stylesheet.defination} p-5`}>
                  <h4>Nature as technology</h4>
                  <h6>
                    Nature’s ingenious solutions have helped in the protection
                    of our harvest, becoming an essential and inspirational
                    element of our technology.
                  </h6>
                  <p>
                    Growing plants while <b>respecting the environment</b> is an
                    important challenge that MA True Cannabis has embraced as an
                    authentic business philosophy.<br></br>
                    <br></br>
                    Relying on entirely organic elements and with the aid of the
                    most recent <b>biodynamic techniques,</b> this guarantees a
                    Cannabis Flowers production with a unique global quality.{" "}
                    <b>100% organic, with no harmful chemicals.</b>
                  </p>
                  <Link>SHOP FLOWERS</Link>
                </div>
                <div className={`col-lg-6 ${stylesheet.definationImage} p-5`}>
                  <div className={stylesheet.definationImage_inner}>
                    <img src="" alt="" />
                  </div>
                </div>

                <div className={`col-lg-6 ${stylesheet.definationImage} p-5`}>
                  <div className={stylesheet.definationImage_inner}>
                    <img src="" alt="" />
                  </div>
                </div>
                <div className={`col-lg-6 ${stylesheet.defination} p-5`}>
                  <h4>Our path to officinal herbs</h4>
                  <h6>
                    We are the first brand in the world to introduce Pre-Rolled
                    CBD cannabis joints, combining Cannabis Flowers made from
                    our True Cannabis production with organic officinal herbs.
                  </h6>
                  <p>
                    The choice of officinal herbs follows a strict process of
                    selection, analysis, and quality control. Our raw material
                    supply process is based only on products that have a
                    certified organic origin and are purchased from producers
                    who are regularly visited by our agronomists, resulting in a
                    product that matches our guaranteed quality and reliability
                    levels.
                    <br></br>
                    <br></br>
                    The medicinal herbs in our CBD Cannabis joints come from
                    organic farms in Europe, Asia, and Africa. Only high-quality
                    ingredients are included in our products to offer the unique
                    experience that only MA True Cannabis can give.
                  </p>
                  <Link>SHOP PRE-ROLLED</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <Footer />
      </div>
    </>
  );
};

export default React.memo(Faqs);
